import { formatPhoneNumber, PolicyDetails } from "shared";
import styles from "./PolicyInfo.module.scss";
import { ListCard } from "../../ListCard";
import { Link } from "../../Link";

type PolicyInfoBrokerProps = {
  policy: PolicyDetails;
};

export const PolicyInfoBroker = ({ policy }: PolicyInfoBrokerProps) => {
  const { broker } = policy;

  if (!broker) {
    return null;
  }

  const { name, phone, phoneExtension } = broker;
  const formattedPhone = formatPhoneNumber(phone);

  return (
    <ListCard.Row>
      <div className={styles.column} data-testid="broker-details">
        <div className={styles.name}>Agent</div>
        <div className={styles.details}>
          {name}
          {phone && (
            <div>
              <Link className={styles.link} phoneNumber={phone}>
                {formattedPhone}
              </Link>
              {phoneExtension && <span>{`, ext. ${phoneExtension}`}</span>}
            </div>
          )}
        </div>
      </div>
    </ListCard.Row>
  );
};
